import React, { useState } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function ExpandableCard({ values = {} }: { values?: FieldValues }) {
  const [expanded, setExpanded] = useState(false)
  const stiffness = values.stiffness ?? 300
  const damping = values.damping ?? 30
  const contentDuration = values.contentDuration ?? 0.3

  return (
    <div className="flex items-center justify-center h-full p-4">
      <motion.div
        layout
        onClick={() => setExpanded(!expanded)}
        className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden cursor-pointer w-full max-w-[200px]"
        transition={{ layout: { type: 'spring', stiffness, damping } }}
      >
        <motion.div layout="position" className="p-3">
          <motion.div layout="position" className="flex items-center gap-2 mb-1">
            <div className="w-6 h-6 rounded-full bg-indigo-500 shrink-0" />
            <span className="text-xs font-semibold text-gray-800">Card Title</span>
          </motion.div>
          <motion.p layout="position" className="text-[10px] text-gray-500">
            Click to {expanded ? 'collapse' : 'expand'}
          </motion.p>
        </motion.div>
        <AnimatePresence>
          {expanded && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: contentDuration }}
              className="overflow-hidden"
            >
              <div className="px-3 pb-3 border-t border-gray-50 pt-2">
                <p className="text-[10px] text-gray-400 leading-relaxed">
                  This content reveals smoothly using layout animations and AnimatePresence for enter/exit.
                </p>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  )
}
